'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
// Generated by CoffeeScript 1.12.2
var Loading_Markup = void 0;

Loading_Markup = function () {
    function Loading_Markup() {
        return '<div class="loading clearfix"><div class="dot dot1"></div><div class="dot dot2"></div><div class="dot dot3"></div><div class="dot dot4"></div></div>';
    }

    return Loading_Markup;
}();

exports.default = Loading_Markup;